var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5bf4c1;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LogoLove") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.43,13A15,15,0,0,0,46.85,11a15.33,15.33,0,0,0-12.08,6,15.33,15.33,0,0,0-12.09-6A15,15,0,0,0,15.11,13,16.88,16.88,0,0,0,7,27.62a17.65,17.65,0,0,0,.77,5.14c2.7,12.86,27,29.07,27,29.07s24.3-16.21,27-29.07a17.32,17.32,0,0,0,.78-5.14A16.88,16.88,0,0,0,54.43,13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLove);
export default __webpack_public_path__ + "static/media/LogoLove.aa5af32794914ceda712b82e8c56d6ce.svg";
export { ForwardRef as ReactComponent };